// @ts-nocheck

import { Component } from '@theme/component';

class PurchaseOptions extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#initialize();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#teardown();
    this.#initialize();
  }

  disconnectedCallback() {
    this.#teardown();
    super.disconnectedCallback();
  }

  refresh() {
    this.#teardown();
    this.#initialize();
  }

  #initialize() {
    console.log('initialize');
    this.product = JSON.parse(this.dataset.product || '{}');
    this.variantId = Number(this.dataset.variantId);
    this.sellingPlanGroups = JSON.parse(this.dataset.sellingPlanGroups || '[]').filter(
      (group) => !group.name?.toLowerCase().includes('dynamic box')
    );
    this.defaultToSubscriptionOnVariantChange = this.dataset.defaultToSubscriptionOnVariantChange === 'true';
    this.frequencyVisible = this.dataset.frequencyVisible === 'true';
    this.selectFrequencyText = this.dataset.selectFrequencyText || '';
    const productFormId = this.dataset.productFormId;
    if (!productFormId) return;

    this.form = document.getElementById(productFormId);
    this.widget = this.querySelector('.rtx-subscription');
    this.purchaseTypeLabel = this.querySelector('.purchaseTypeLbl');
    this.subscriptionBox = this.querySelector('.rtx-subscription-box');
    this.sellingPlanSelector = this.querySelector('[name="rtx_selling_plan"]');
    this.subscriptionLabel = this.querySelector('[data-purchase-type="subscription"]');
    this.oneTimeLabel = this.querySelector('[data-purchase-type="one-time"]');

    if (!this.widget || !this.form || !this.sellingPlanSelector) return;

    this.sellingPlanInput = this.form.querySelector('[name="selling_plan"]');
    this.purchaseTypeInputs = this.querySelectorAll('[name^="purchaseType-"]');
    this.variantSelectors = this.form.querySelectorAll('[name="id"]');

    this.purchaseTypeInputs.forEach((input) => input.addEventListener('change', this.handlePurchaseTypeChange));
    this.sellingPlanSelector.addEventListener('change', this.updateSellingPlan);
    this.variantSelectors.forEach((input) => input.addEventListener('change', this.handleVariantChange));

    this.showWidget(this.currentVariant);
    window.retextionApi?.productAdd?.({ product: this.product });
  }

  #teardown() {
    this.purchaseTypeInputs?.forEach((input) => input.removeEventListener('change', this.handlePurchaseTypeChange));
    this.sellingPlanSelector?.removeEventListener('change', this.updateSellingPlan);
    this.variantSelectors?.forEach((input) => input.removeEventListener('change', this.handleVariantChange));
  }

  get currentVariant() {
    return this.product.variants?.find((variant) => Number(variant.id) === this.variantId);
  }

  get isSubscriptionSelected() {
    return this.subscriptionLabel?.classList.contains('is-selected') ?? false;
  }

  handlePurchaseTypeChange = (event) => {
    if (!(event.target instanceof HTMLInputElement)) return;
    if (event.target.value.includes('purchaseTypeSubscription')) {
      this.showSubscriptionBox();
    } else {
      this.hideSubscriptionBox();
    }
  };

  handleVariantChange = (event) => {
    if (!(event.target instanceof HTMLInputElement)) return;
    this.variantId = Number(event.target.value);
    this.showWidget(this.currentVariant);
  };

  showWidget(variant) {
    if (!variant) return;

    const plans = variant.selling_plan_allocations
      .map((allocation) => {
        const group = this.sellingPlanGroups.find((item) => String(item.id) === String(allocation.selling_plan_group_id));
        return group?.selling_plans.find((plan) => String(plan.id) === String(allocation.selling_plan_id));
      })
      .filter(Boolean);

    if (!plans.length) {
      this.widget.hidden = true;
      if (this.purchaseTypeLabel) this.purchaseTypeLabel.hidden = true;
      this.hideSubscriptionBox();
      return;
    }

    this.widget.hidden = false;
    if (this.purchaseTypeLabel) this.purchaseTypeLabel.hidden = false;
    this.sellingPlanSelector.replaceChildren(...plans.map((plan) => new Option(plan.options?.[0]?.value || plan.name, plan.id)));

    if (this.defaultToSubscriptionOnVariantChange && !this.isSubscriptionSelected) {
      this.subscriptionLabel?.querySelector('input')?.click();
    }

    this.updateSellingPlan();
  }

  showSubscriptionBox() {
    this.subscriptionBox?.classList.add('is-visible');
    this.subscriptionLabel?.classList.add('is-selected');
    this.oneTimeLabel?.classList.remove('is-selected');
    this.sellingPlanSelector.removeAttribute('disabled');
    this.updateSellingPlan();
  }

  hideSubscriptionBox() {
    if (!this.frequencyVisible) this.subscriptionBox?.classList.remove('is-visible');
    this.subscriptionLabel?.classList.remove('is-selected');
    this.oneTimeLabel?.classList.add('is-selected');
    this.sellingPlanSelector.setAttribute('disabled', '');
    if (this.sellingPlanInput) this.sellingPlanInput.value = '';
  }

  updateSellingPlan = () => {
    if (!this.isSubscriptionSelected || !this.sellingPlanSelector.value) {
      if (this.sellingPlanInput) this.sellingPlanInput.value = '';
      return;
    }

    if (!this.sellingPlanInput) {
      this.sellingPlanInput = document.createElement('input');
      this.sellingPlanInput.type = 'hidden';
      this.sellingPlanInput.name = 'selling_plan';
      this.form.append(this.sellingPlanInput);
    }

    this.sellingPlanInput.value = this.sellingPlanSelector.value;
  };
}

if (!customElements.get('purchase-options')) {
  customElements.define('purchase-options', PurchaseOptions);
}
